// @ts-nocheck
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUser, setUser } from "../auth/auth";
import { performLogout } from "../auth/logout";
import { cancelAccountDeletion } from "../api/moderation";
import TopNav from "../components/TopNav";
import { useToast } from "../components/ToastProvider";
import "../styles/Settings.css";

function Settings() {
  const navigate = useNavigate();
  const user = getUser();
  const { showToast } = useToast();
  const [deletionRequested, setDeletionRequested] = useState(Boolean(user?.deletionRequested || user?.deletionScheduledFor));
  const [deletionDate, setDeletionDate] = useState(user?.deletionScheduledFor || null);

  const handleCancelDeletion = async () => {
    try {
      await cancelAccountDeletion(user.id);
      setDeletionRequested(false);
      setDeletionDate(null);
      setUser({
        ...user,
        deletionRequested: false,
        deletionRequestedAt: null,
        deletionScheduledFor: null,
      });
      showToast("Deletion request cancelled", "success");
    } catch (error) {
      console.error("Error canceling deletion:", error);
      showToast("Failed to cancel deletion. Please try again.", "error");
    }
  };

  const handleLogout = () => {
    performLogout();
  };

  return (
    <>
      <TopNav />
      <div className="settings-page page-with-top-nav">
        <div className="settings-header">
          <h1>Settings</h1>
        </div>

        <div className="settings-sections">
          {/* Legal Section */}
          <div className="settings-section">
            <h2>Legal</h2>
            <div className="settings-list">
              <button className="settings-item" onClick={() => navigate("/terms")}>
                <span>Terms of Service</span>
                <span className="arrow">→</span>
              </button>
              <button className="settings-item" onClick={() => navigate("/privacy")}>
                <span>Privacy Policy</span>
                <span className="arrow">→</span>
              </button>
              <button className="settings-item" onClick={() => navigate("/dispute-policy")}>
                <span>Dispute Policy</span>
                <span className="arrow">→</span>
              </button>
              <button className="settings-item" onClick={() => navigate("/ip-disclaimer")}>
                <span>IP Disclaimer</span>
                <span className="arrow">→</span>
              </button>
              <button className="settings-item" onClick={() => navigate("/safety")}>
                <span>Safety Center</span>
                <span className="arrow">→</span>
              </button>
            </div>
          </div>

          {/* Account Section */}
          <div className="settings-section">
            <h2>Account</h2>
            <div className="settings-list">
              {deletionRequested ? (
                <div className="deletion-status">
                  <p className="deletion-text">
                    Deletion scheduled for {new Date(deletionDate).toLocaleDateString()}
                  </p>
                  <button className="cancel-deletion-btn" onClick={handleCancelDeletion}>
                    Cancel deletion request
                  </button>
                </div>
              ) : (
                <button className="settings-item danger" onClick={() => navigate("/account-deletion")}>
                  <span>Request account deletion</span>
                </button>
              )}
              <button className="settings-item" onClick={handleLogout}>
                <span>Log Out</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}

export default Settings;
